export const environment = {
  production: true,
  baseUrl: 'https://yccas48sw0.execute-api.ap-southeast-1.amazonaws.com/uat/v1',
  webSocketUrl: 'wss://3gkinjqd5i.execute-api.ap-southeast-1.amazonaws.com/uat'
};
